import { render, staticRenderFns } from "./lk-course-rate.vue?vue&type=template&id=dcb04808&"
import script from "./lk-course-rate.vue?vue&type=script&lang=js&"
export * from "./lk-course-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-course/lk-course-rate/lk-course-rate.vue
// module id = 1207
// module chunks = 0